module.exports = __webpack_public_path__ + "static/page-5-d13e410be3811236a1468db5b9d24fa1.jpg";